import { render, staticRenderFns } from "./DelStorageFile.vue?vue&type=template&id=596f3455&"
import script from "./DelStorageFile.vue?vue&type=script&lang=js&"
export * from "./DelStorageFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports